import axios from 'axios';

import config from '../configs';
import utils from '../utils';
import services from '../services';

const loanService = {
  getLoanOffer: (successCallback, errorCallback) => {
    axios
      .get(
        config.apiUrl +
        'loan_offer?phone_number=' +
        utils.store.get('phoneNumber'),
        {
          headers: {
            Authorization: utils.store.get('preAuthToken')
              ? utils.store.get('preAuthToken')
              : utils.store.get('preAuthToken1'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('preAuthToken')
            ? utils.store.get('preAuthToken')
            : utils.store.get('preAuthToken1'),
        );
        errorCallback(exception);
      });
  },

  getPaymentPlans: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'payment_plans', payload, {
        headers: {
          Authorization: utils.store.get('preAuthToken')
            ? utils.store.get('preAuthToken')
            : utils.store.get('preAuthToken1'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('preAuthToken')
            ? utils.store.get('preAuthToken')
            : utils.store.get('preAuthToken1'),
        );
        errorCallback(exception);
      });
  },

  choosePaymentPlan: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'choose_payment_plan', payload, {
        headers: {
          Authorization: utils.store.get('preAuthToken')
            ? utils.store.get('preAuthToken')
            : utils.store.get('preAuthToken1'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('preAuthToken')
            ? utils.store.get('preAuthToken')
            : utils.store.get('preAuthToken1'),
        );
        errorCallback(exception);
      });
  },

  apply: async (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'loan', payload)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, payload, '');
        errorCallback(exception);
      });
  },

  getAgreementSummary: async (payload, successCallback, errorCallback) => {
    axios
      .get(
        config.apiUrl + 'loan/agreement_summary?loan_xid=' + payload.loan_xid,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getAgreementLetter: async (payload, successCallback, errorCallback) => {
    axios
      .get(
        config.apiUrl + 'loan/agreement_letter?loan_xid=' + payload.loan_xid,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getLoans: async (payload, successCallback, errorCallback) => {
    axios
      .get(
        config.apiUrl +
        'loans?account_id=' +
        payload.account_id +
        '&type=' +
        payload.type,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getLoanPayments: async (payload, successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'loan/payments?loan_xid=' + payload.loan_xid, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getLoanPaymentDetail: async (successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'loan/payment', {
        headers: {
          Authorization: utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getLoanDetail: async (payload, successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'loan_review?loan_xid=' + payload.loan_xid, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getApplicationStatus: async (successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'application/status', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getLoan: async (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'loan', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getInfoCard: async (successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'common/info_cards', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getRegisterStatus: async (payload, successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'get_grab_reregister_status', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getSelectedLoanData: async () =>
    axios
      .get(config.apiUrl + 'loan/transaction-detail', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          null,
          utils.store.get('token'),
        );
      }),
};

export default loanService;
